export default __webpack_public_path__ + "static/media/close-error.25519466.svg";